import { Dispatch, AnyAction } from 'redux';
import { UseMutateFunction } from 'react-query';
import { LogyxError } from 'services/api/errors';
import { ISelectCompanyDTO } from './hooks';
import { decodeTokenAndSetUserData } from 'pages/Auth/LoginPage/helpers';
import LocalStorageService from 'services/LocalStorageService';
import { LOCAL_STORAGE_ACCESS_TOKEN } from 'services/api/constants';
import { companyChanged, setCompany } from 'store/User/actions/user';
import { ICompany } from 'types/Company.types';
import { toast } from 'react-toastify';
import { TFunction } from 'i18next';
import { setAppMode } from 'store/Common/actions/common';
import { AppMode } from 'store/Common/reducers/common';
import { getAppModeBasedOnCompanyRole } from '../helpers';
import { queryClient } from 'index';

export const handleSelectCompany = (
  dispatch: Dispatch<AnyAction>,
  selectCompany: UseMutateFunction<any, LogyxError, ISelectCompanyDTO, unknown>,
  company: ICompany,
  t: TFunction,
  appMode: AppMode
) => {
  const dto: ISelectCompanyDTO = {
    companyId: company.id,
  };
  selectCompany(dto, {
    onSuccess: async (data) => {
      if (data?.access_token) {
        decodeTokenAndSetUserData(data.access_token, dispatch);
        await LocalStorageService.setItem(
          LOCAL_STORAGE_ACCESS_TOKEN,
          data.access_token
        );
        dispatch(setCompany(company));
        // The newly selected company might not have the permissions for the current app mode
        const newAppMode = getAppModeBasedOnCompanyRole(company.role, appMode);
        if (newAppMode !== appMode) {
          dispatch(setAppMode(newAppMode));
        }
        // Every slice holding data scoped to the previous company resets on this
        dispatch(companyChanged());
        // Cached lists (orders, quotations, models, buyers, users, cart) belong
        // to the previous company.
        queryClient.removeQueries();
        toast.success(t('Successfully changed company'));
      } else {
        console.error('No access token received from company selection');
      }
    },
    onError: (error) => {
      console.error('Failed to select company:', error);
    },
  });
};
